var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widM famliy01-check" },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "space-between",
            "align-items": "center"
          }
        },
        [
          _c(
            "p",
            {
              staticClass: "fntH6 fntL bold marTML marBM",
              staticStyle: { color: "#2c2c2c", width: "49%" }
            },
            [
              _vm._v(
                _vm._s(_vm.getTextByType(_vm.participant) + " " + (_vm.idx + 1))
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "fntH6 marTML marBM",
              staticStyle: {
                background: "none",
                "vertical-align": "middle",
                display: "flex",
                "align-items": "center"
              },
              on: {
                click: function($event) {
                  return _vm.removeFamily(_vm.idx)
                }
              }
            },
            [
              _c("em", { staticClass: "disbl marRS" }, [_vm._v("삭제")]),
              _c("img", {
                staticClass: "FamilyDlt disBl",
                attrs: {
                  src:
                    "https://www.amway.co.kr/_ui/_noticeImg/2022/09/0929_NCAcmi/btn_close.png",
                  alt: "파일 삭제 버튼"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth" }, [
          _c(
            "div",
            {
              staticClass: "pf23-inFo-select pf23-family-relative",
              staticStyle: { "margin-left": "auto" }
            },
            [
              _c(
                "select",
                {
                  staticClass: "form-control",
                  class:
                    _vm.ishint && _vm.participant.questions["Q218"].hasError
                      ? "check-red"
                      : "",
                  attrs: { id: "Q218-" + _vm.resIdx, disabled: _vm.disabled },
                  domProps: {
                    value: _vm.participant.questions["Q218"].raw_data
                  },
                  on: {
                    change: function($event) {
                      return _vm.changeFamilyRelation(
                        _vm.resIdx,
                        "Q218",
                        $event.target
                      )
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [_vm._v("관계 선택")]),
                  _vm._v(" "),
                  _vm._l(_vm.familyRelations, function(family, index) {
                    return [
                      _c(
                        "option",
                        {
                          key: index,
                          attrs: {
                            checked:
                              _vm.participant.questions["Q218"].raw_data ==
                              family.CODE
                          },
                          domProps: { value: family.CODE }
                        },
                        [_vm._v(_vm._s(family.LABEL))]
                      )
                    ]
                  })
                ],
                2
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm"
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _c("input", {
              attrs: {
                type: "text",
                name: "NCAcmi_family_name01",
                maxlength: "30",
                id: "NCAcmi_name-" + _vm.resIdx,
                disabled: _vm.disabled,
                oninput:
                  "javascript: this.value = this.value.replace(/[^a-z|A-Z|ㄱ-ㅎ|ㅏ-ㅣ|가-힣|-ㆍᆢ]/g, '' );"
              },
              domProps: { value: _vm.familyName },
              on: {
                input: function($event) {
                  return _vm.inputFamilyName(_vm.resIdx, $event.target)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [_vm._v("\n    *외국인의 경우 이름(영문)으로 입력\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-C padBSM padTSM pf23-inFo-common" }, [
        _c("div", { staticClass: "pf23-input-wrap" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _vm._v("\n        010 -"),
            _c("input", {
              class:
                _vm.participant.questions["Q200"].hasError &&
                _vm.participant.questions["Q200"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                maxlength: "8",
                placeholder: "- 없이 입력",
                size: "50",
                id: "Q200-" + _vm.resIdx,
                disabled: _vm.disabled
              },
              domProps: { value: _vm.participant.questions["Q200"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberFixWordAnswer(
                    _vm.resIdx,
                    "Q200",
                    $event.target,
                    8
                  )
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.participant.questions["Q200"].hasError &&
      _vm.participant.questions["Q200"].raw_data
        ? _c(
            "p",
            {
              staticClass: "marTS fntE hintHeight",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [[_vm._v("🚫 010 뒤의 숫자 8자리를 입력해주세요.")]],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [_vm._v("\n    *휴대폰 번호가 없는 경우 보호자의 휴대폰 번호 입력\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-lineBtm" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth" }, [
          _c("div", { staticClass: "amway-theme" }, [
            _c(
              "div",
              {
                staticClass:
                  "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
              },
              [
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "DOMESTIC",
                        id: "Q201-" + _vm.resIdx,
                        name: "domestic-radio-" + _vm.resIdx,
                        disabled: _vm.disabled
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q201"].raw_data ===
                          "DOMESTIC"
                      },
                      on: {
                        change: function($event) {
                          _vm.inputRadioDomesticAnswer(
                            _vm.resIdx,
                            "Q201",
                            "DOMESTIC"
                          )
                          _vm.inputSelectAnswer(
                            _vm.resIdx,
                            "Q207",
                            null,
                            "대한민국"
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("내국인")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "FOREIGNER",
                        name: "domestic-radio-" + _vm.resIdx,
                        disabled: _vm.disabled
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q201"].raw_data ===
                          "FOREIGNER"
                      },
                      on: {
                        change: function($event) {
                          _vm.inputRadioDomesticAnswer(
                            _vm.resIdx,
                            "Q201",
                            "FOREIGNER"
                          )
                          _vm.inputSelectAnswer(_vm.resIdx, "Q207", null, "")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("외국인")
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "padTSM padBSM",
          attrs: { id: "pf23-family01-personal" }
        },
        [
          _c("div", { staticClass: "pf23-inFo-L pf23-inFo-common" }, [
            _c(
              "label",
              {
                staticClass: "fntP txtL",
                attrs: { for: "pf23-family01-Personal01-1" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.participant.questions["Q201"].raw_data == "FOREIGNER"
                        ? "외국인등록번호"
                        : "주민등록번호"
                    )
                ),
                _c("span", { staticClass: "ico-must-astar" })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "pf12-familyWidth" }, [
              _c("div", { staticClass: "txtR pf12-familyWidth-personal" }, [
                _c("em", { staticClass: "txtR disIb" }, [
                  _c("input", {
                    staticClass: "NCAcmi_num",
                    class:
                      _vm.participant.questions["Q202"].hasError &&
                      _vm.participant.questions["Q202"].raw_data
                        ? "check-red"
                        : "",
                    staticStyle: { width: "45%" },
                    attrs: {
                      type: "text",
                      maxlength: "6",
                      id: "Q202-" + _vm.resIdx,
                      name: "NCAcmi_personal" + _vm.resIdx + "-1",
                      disabled:
                        _vm.disabled ||
                        _vm.participant.questions["Q201"].hasError
                    },
                    domProps: {
                      value: _vm.participant.questions["Q202"].raw_data
                    },
                    on: {
                      input: function($event) {
                        return _vm.inputJuminFirstNumber(
                          _vm.resIdx,
                          "Q202",
                          $event.target,
                          true
                        )
                      }
                    }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "disIb txtC",
                      staticStyle: { width: "10%" }
                    },
                    [_vm._v("-\n              ")]
                  ),
                  _c("input", {
                    staticClass: "NCAcmi_num",
                    class:
                      _vm.participant.questions["Q203"].hasError &&
                      _vm.participant.questions["Q203"].raw_data
                        ? "check-red"
                        : "",
                    staticStyle: { width: "45%" },
                    attrs: {
                      type: "text",
                      maxlength: "7",
                      id: "Q203-" + _vm.resIdx,
                      name: "NCAcmi_personal" + _vm.resIdx + "-2",
                      disabled:
                        _vm.disabled ||
                        _vm.participant.questions["Q201"].hasError
                    },
                    domProps: {
                      value: _vm.participant.questions["Q203"].raw_data
                    },
                    on: {
                      input: function($event) {
                        return _vm.inputJuminLastNumber(
                          _vm.resIdx,
                          "Q203",
                          $event.target,
                          "Q206"
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [
          (_vm.participant.questions["Q202"].hasError ||
            _vm.participant.questions["Q203"].hasError) &&
          (_vm.participant.questions["Q202"].raw_data ||
            _vm.participant.questions["Q203"].raw_data)
            ? [_vm._v("\n    🚫 " + _vm._s(_vm.juminHasError) + "\n    ")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-lineBtm" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth" }, [
          _c("div", { staticClass: "amway-theme" }, [
            _c(
              "div",
              {
                staticClass:
                  "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
              },
              [
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "FEMALE",
                        id: "Q206-" + _vm.resIdx,
                        name: "-radio-" + _vm.resIdx,
                        disabled: true
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q206"].raw_data ===
                          "FEMALE"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("여성")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "MALE",
                        name: "sex-radio-" + _vm.resIdx,
                        disabled: true
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q206"].raw_data === "MALE"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("남성")
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em",
            height: "21px"
          }
        },
        [_vm._v("* 주민/외국인 등록번호에 따라 자동선택됩니다.")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm",
          staticStyle: { "border-top": "1px solid #e3e3e3" }
        },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q204"].hasError &&
                _vm.participant.questions["Q204"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "30",
                placeholder: "여권 영문 성",
                id: "Q204-" + _vm.resIdx,
                name: "NCAcmi_engname01" + _vm.resIdx + "-1",
                disabled: _vm.disabled
              },
              domProps: { value: _vm.participant.questions["Q204"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputEngAnswer(_vm.resIdx, "Q204", $event.target)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [
          _vm.participant.questions["Q204"].hasError &&
          _vm.participant.questions["Q204"].raw_data
            ? [_vm._v("🚫 2자 이상 영문으로 입력해주세요.")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm"
        },
        [
          _vm._m(6),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.participant.questions["Q205"].hasError &&
                _vm.participant.questions["Q205"].raw_data
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "30",
                placeholder: "여권 영문 이름",
                id: "Q205-" + _vm.resIdx,
                name: "NCAcmi_engname02" + _vm.resIdx + "-1",
                disabled: _vm.disabled
              },
              domProps: { value: _vm.participant.questions["Q205"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputEngAnswer(_vm.resIdx, "Q205", $event.target)
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [
          _vm.participant.questions["Q205"].hasError &&
          _vm.participant.questions["Q205"].raw_data
            ? [_vm._v("🚫 2자 이상 영문으로 입력해주세요.")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm"
        },
        [
          _vm._m(7),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth" }, [
            _c(
              "div",
              {
                staticClass: "pf23-inFo-select pf23-country",
                staticStyle: { "margin-left": "auto" }
              },
              [
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    class:
                      _vm.ishint && _vm.participant.questions["Q207"].hasError
                        ? "check-red"
                        : "",
                    attrs: {
                      id: "Q207-" + _vm.resIdx,
                      disabled:
                        _vm.disabled ||
                        _vm.participant.questions["Q201"].raw_data ===
                          "DOMESTIC"
                    },
                    domProps: {
                      value: _vm.participant.questions["Q207"].raw_data
                    },
                    on: {
                      change: function($event) {
                        return _vm.inputSelectAnswer(
                          _vm.resIdx,
                          "Q207",
                          $event.target
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("국가선택")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.counties, function(country, index) {
                      return [
                        _c(
                          "option",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.participant.questions["Q201"].raw_data !==
                                    "DOMESTIC" &&
                                  country.COUNTRY_KOR_NM !== "대한민국",
                                expression:
                                  "participant.questions['Q201'].raw_data !== 'DOMESTIC' && country.COUNTRY_KOR_NM !== '대한민국'"
                              }
                            ],
                            key: index,
                            attrs: {
                              checked:
                                _vm.participant.questions["Q207"].raw_data ==
                                country.COUNTRY_KOR_NM
                            },
                            domProps: { value: country.COUNTRY_KOR_NM }
                          },
                          [
                            _vm._v(
                              _vm._s(country.COUNTRY_ISO_WORD3) +
                                " - " +
                                _vm._s(country.COUNTRY_KOR_NM)
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.participant.questions["Q201"].raw_data === "DOMESTIC"
        ? _c(
            "p",
            {
              staticClass: "marTS fntE hintHeight",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [_vm._v("* 내국인은 대한민국 자동 선택됩니다.")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.participant.questions["Q201"].raw_data !== "DOMESTIC"
        ? _c(
            "p",
            {
              staticClass: "marTS fntE hintHeight",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [
              _vm.ishint && _vm.participant.questions["Q207"].hasError
                ? [_vm._v("🚫 국가를 선택해 주세요.")]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "padBSM padTSM pf23-inFo-common pf23-lineBtm" },
        [
          _c("div", { staticClass: "pf23-inFo-L" }, [
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "pf12-familyWidth txtR" }, [
              _c("input", {
                staticClass: "NCAcmi_num",
                class:
                  _vm.participant.questions["Q208"].hasError &&
                  _vm.participant.questions["Q208"].raw_data
                    ? "check-red"
                    : "",
                attrs: {
                  type: "text",
                  size: "50",
                  maxlength: "20",
                  id: "Q208-" + _vm.resIdx,
                  name: "NCAcmi_passportnumber" + _vm.resIdx + "-1",
                  disabled: _vm.disabled
                },
                domProps: { value: _vm.participant.questions["Q208"].raw_data },
                on: {
                  input: function($event) {
                    return _vm.inputPassportAnswer(
                      _vm.resIdx,
                      "Q208",
                      $event.target
                    )
                  }
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common" }, [
        _vm._m(9),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth txtR" }, [
          _c("input", {
            staticClass: "NCAcmi_num",
            class:
              _vm.ishint && _vm.participant.questions["Q209"].hasError
                ? "check-red"
                : "",
            attrs: {
              type: "date",
              size: "50",
              maxlength: "50",
              id: "Q209-" + _vm.resIdx,
              name: "NCAcmi_passportfrom" + _vm.resIdx,
              disabled: _vm.disabled,
              max: _vm.today
            },
            domProps: { value: _vm.participant.questions["Q209"].raw_data },
            on: {
              change: function($event) {
                return _vm.inputPassportDateAnswer(
                  _vm.resIdx,
                  "Q209",
                  $event.target
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [
          _vm.ishint && _vm.participant.questions["Q209"].hasError
            ? [
                _vm._v(
                  "🚫 " +
                    _vm._s(
                      _vm.participant.questions["Q209"].remarks
                        ? _vm.participant.questions["Q209"].remarks
                        : "여권발급일을 선택해주세요."
                    )
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-inFo-common" }, [
        _vm._m(10),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth txtR" }, [
          _c("input", {
            staticClass: "NCAcmi_num",
            class:
              _vm.ishint && _vm.participant.questions["Q210"].hasError
                ? "check-red"
                : "",
            attrs: {
              type: "date",
              size: "50",
              maxlength: "50",
              id: "Q210-" + _vm.resIdx,
              name: "NCAcmi_passportend" + _vm.resIdx,
              disabled: _vm.disabled,
              min: _vm.today
            },
            domProps: { value: _vm.participant.questions["Q210"].raw_data },
            on: {
              change: function($event) {
                _vm.inputPassportDateAnswer(_vm.resIdx, "Q210", $event.target)
                _vm.navtiveAlert(
                  "여권 만료일은 출국일로부터 6개월 이상이어야 합니다.\n잔여 유효기간이 6개월 미만인 경우 여권을 재발급 받은 후 담당 여행사 (02-2022-6520)로 연락주시기 바랍니다."
                )
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em"
          }
        },
        [
          _vm.ishint && _vm.participant.questions["Q210"].hasError
            ? [
                _vm._v(
                  "🚫 " +
                    _vm._s(
                      _vm.participant.questions["Q210"].remarks
                        ? _vm.participant.questions["Q210"].remarks
                        : "여권만료일을 선택해주세요."
                    )
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm",
          staticStyle: { "border-top": "1px solid #e3e3e3" }
        },
        [
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q211"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "3",
                placeholder: "cm 단위",
                id: "Q211-" + _vm.resIdx,
                name: "NCAcmi_passportnumber" + _vm.resIdx + "-1",
                disabled: _vm.disabled
              },
              domProps: { value: _vm.participant.questions["Q211"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberAnswer(
                    _vm.resIdx,
                    "Q211",
                    $event.target
                  )
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em",
            height: "21px"
          }
        },
        [
          _vm.ishint && _vm.participant.questions["Q211"].hasError
            ? [_vm._v("🚫 신장을 입력해 주시기 바랍니다.")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm",
          staticStyle: { "border-top": "1px solid #e3e3e3" }
        },
        [
          _vm._m(12),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth txtR" }, [
            _c("input", {
              staticClass: "NCAcmi_num",
              class:
                _vm.ishint && _vm.participant.questions["Q212"].hasError
                  ? "check-red"
                  : "",
              attrs: {
                type: "text",
                size: "50",
                maxlength: "3",
                placeholder: "kg 단위",
                id: "Q212-" + _vm.resIdx,
                name: "NCAcmi_passportnumber" + _vm.resIdx + "-1",
                disabled: _vm.disabled
              },
              domProps: { value: _vm.participant.questions["Q212"].raw_data },
              on: {
                input: function($event) {
                  return _vm.inputNumberAnswer(
                    _vm.resIdx,
                    "Q212",
                    $event.target
                  )
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE hintHeight",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em",
            height: "21px"
          }
        },
        [
          _vm.ishint && _vm.participant.questions["Q212"].hasError
            ? [_vm._v("🚫 체중을 입력해 주시기 바랍니다.")]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm",
          staticStyle: { "border-top": "1px solid #e3e3e3" }
        },
        [
          _vm._m(13),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth" }, [
            _c(
              "div",
              {
                staticClass: "pf23-inFo-select pf23-footSize",
                staticStyle: { "margin-left": "auto" }
              },
              [
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    class:
                      _vm.ishint && _vm.participant.questions["Q213"].hasError
                        ? "check-red"
                        : "",
                    attrs: {
                      name: "pf23-family01-footSize01",
                      id: "Q213-" + _vm.resIdx,
                      disabled: _vm.disabled
                    },
                    domProps: {
                      value: _vm.participant.questions["Q213"].raw_data
                    },
                    on: {
                      change: function($event) {
                        return _vm.inputSelectAnswer(
                          _vm.resIdx,
                          "Q213",
                          $event.target
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("사이즈선택")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.shoeSize, function(item, index) {
                      return [
                        _c(
                          "option",
                          {
                            key: index,
                            attrs: {
                              checked:
                                _vm.participant.questions["Q213"].raw_data ==
                                item.CODE
                            },
                            domProps: { value: item.CODE }
                          },
                          [_vm._v(_vm._s(item.LABEL))]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "marTS fntE",
          staticStyle: {
            color: "#d91734",
            "text-indent": "-0.6em",
            "padding-left": "0.6em",
            height: "21px"
          }
        },
        [_vm._v("* 신발 사이즈 195mm 이하는 스키만 선택이 가능합니다.")]
      ),
      _vm._v(" "),
      _vm.ishint && _vm.participant.questions["Q213"].hasError
        ? _c(
            "p",
            {
              staticClass: "marTS fntE hintHeight",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [_vm._v("🚫 신발사이즈를 선택해 주세요.")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pf23-inFo-L padBSM padTSM pf23-lineBtm" }, [
        _vm._m(14),
        _vm._v(" "),
        _c("div", { staticClass: "pf12-familyWidth" }, [
          _c("div", { staticClass: "amway-theme" }, [
            _c(
              "div",
              {
                staticClass:
                  "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
              },
              [
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "스키",
                        name: "reports-radio-" + _vm.resIdx,
                        id: "Q214-" + _vm.resIdx,
                        disabled: _vm.disabled
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q214"].raw_data === "스키"
                      },
                      on: {
                        change: function($event) {
                          return _vm.inputRadioAnswer(
                            "" + _vm.resIdx,
                            "Q214",
                            "스키"
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("스키")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "amw-radio-wrap radio-label focus" },
                  [
                    _c("input", {
                      staticClass: "amw-global-radio",
                      attrs: {
                        type: "radio",
                        value: "보드",
                        name: "reports-radio-" + _vm.resIdx,
                        disabled: _vm.disabled
                      },
                      domProps: {
                        checked:
                          _vm.participant.questions["Q214"].raw_data === "보드"
                      },
                      on: {
                        change: function($event) {
                          return _vm.inputRadioAnswer(
                            "" + _vm.resIdx,
                            "Q214",
                            "보드"
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-radio-overlay" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "amw-label-radio-text" }, [
                      _vm._v("보드")
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm",
          staticStyle: { "border-top": "1px solid #e3e3e3" }
        },
        [
          _vm._m(15),
          _vm._v(" "),
          _c("div", { staticClass: "pf12-familyWidth" }, [
            _c(
              "div",
              {
                staticClass: "pf23-inFo-select pf23-sportLv",
                staticStyle: { "margin-left": "auto" }
              },
              [
                _c(
                  "select",
                  {
                    staticClass: "form-control",
                    class:
                      _vm.ishint && _vm.participant.questions["Q215"].hasError
                        ? "check-red"
                        : "",
                    attrs: {
                      id: "Q215-" + _vm.resIdx,
                      disabled:
                        _vm.disabled ||
                        _vm.participant.questions["Q215"].raw_data ===
                          "DOMESTIC"
                    },
                    domProps: {
                      value: _vm.participant.questions["Q215"].raw_data
                    },
                    on: {
                      change: function($event) {
                        return _vm.inputSelectAnswer(
                          _vm.resIdx,
                          "Q215",
                          $event.target
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("레벨선택")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.sportLevel, function(item, index) {
                      return [
                        _c(
                          "option",
                          {
                            key: index,
                            attrs: {
                              checked:
                                _vm.participant.questions["Q215"].raw_data ==
                                item.CODE
                            },
                            domProps: { value: item.CODE }
                          },
                          [_vm._v(_vm._s(item.LABEL))]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.ishint && _vm.participant.questions["Q215"].hasError
        ? _c(
            "p",
            {
              staticClass: "marTS fntE hintHeight",
              staticStyle: {
                color: "#d91734",
                "text-indent": "-0.6em",
                "padding-left": "0.6em"
              }
            },
            [_vm._v("🚫 레벨을 선택해 주세요.")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "padTSM pf23-lineBtm" }, [
        _vm._m(16),
        _vm._v(" "),
        _c("p", { staticClass: "fntP padTSM " }, [
          _vm._v(
            "‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pf23-inFo-safe-L marTSM" }, [
          _c(
            "div",
            { staticClass: "amway-theme", staticStyle: { width: "55%" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "action pf23-radioBtn radio-wrapper pf23-inFo-radio"
                },
                [
                  _c(
                    "label",
                    { staticClass: "amw-radio-wrap radio-label focus" },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          name: "safe-radio-" + _vm.resIdx,
                          value: "Y",
                          id: "Q217-" + _vm.resIdx,
                          disabled: _vm.disabled
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q217"].raw_data === "Y"
                        },
                        on: {
                          change: function($event) {
                            return _vm.inputRadioAnswer(
                              "" + _vm.resIdx,
                              "Q217",
                              "Y"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("예")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "amw-radio-wrap radio-label focus",
                      staticStyle: { "margin-right": "1.5em" }
                    },
                    [
                      _c("input", {
                        staticClass: "amw-global-radio",
                        attrs: {
                          type: "radio",
                          name: "safe-radio-" + _vm.resIdx,
                          value: "N",
                          disabled: _vm.disabled
                        },
                        domProps: {
                          checked:
                            _vm.participant.questions["Q217"].raw_data === "N"
                        },
                        on: {
                          change: function($event) {
                            return _vm.inputRadioAnswer(
                              "" + _vm.resIdx,
                              "Q217",
                              "N"
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-radio-overlay" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "amw-label-radio-text" }, [
                        _vm._v("아니오")
                      ])
                    ]
                  )
                ]
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "marTS fntE",
            staticStyle: {
              color: "#0075a4",
              "text-indent": "-0.6em",
              "padding-left": "0.6em",
              "padding-bottom": "0.6em"
            }
          },
          [
            _vm._v(
              "* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에\n      작성하여 주시기 바랍니다."
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("SurveyAttachmentFamily", {
        class: { NCAcmi_lineBtm: _vm.showPaymentForm },
        attrs: {
          participant: _vm.participant,
          "sq-code": "Q220",
          disabled: _vm.disabled,
          id: "Q220-" + _vm.resIdx
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family-relative01 txtL" } },
      [_vm._v("가족관계 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-fmaily01-Name01" } },
      [_vm._v("이름(국문) "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-fmaily01-Num01" } },
      [_vm._v("휴대폰 번호"), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-fmaily01-Name01" } },
      [_vm._v("내국인 구분 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("성별 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-en-first01" } },
      [_vm._v("여권 영문 성 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-en-name01" } },
      [_vm._v("여권 영문 이름 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("국가 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-Passport-Num01" } },
      [_vm._v("여권 번호 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("여권 발급일 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("여권 만료일 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-height01" } },
      [_vm._v("신장 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-height01" } },
      [_vm._v("체중 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-footSize01" } },
      [_vm._v("신발 사이즈 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("스키/보드 "),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "fntP", attrs: { for: "pf23-family01-sportLv01" } },
      [_vm._v("스키/보드 레벨 "), _c("span", { staticClass: "ico-must-astar" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "fntP" }, [
      _vm._v("안전 확인"),
      _c("span", { staticClass: "ico-must-astar" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73d333f6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73d333f6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surveys/sapporo/components/SurveyParticipantFamily.vue
// module id = null
// module chunks = 